import { Button, Stack } from '@mui/material';
import SearchCircle from '@/assets/images/svg/search-circle.svg';
import { StateMessage } from '@/components/shared/state-message';

interface EmptyHubStateProps {
  onSearchCourses: () => void;
  onAddExternalCourse: () => void;
}

export const EmptyHubState = ({
  onSearchCourses,
  onAddExternalCourse,
}: EmptyHubStateProps) => (
  <StateMessage
    image={SearchCircle}
    imageSize={{ width: 48, height: 48 }}
    title="Vamos começar?"
    description="Explore cursos recomendados para você ou adicione um que você já iniciou fora da Galena."
    backgroundColor="transparent"
    customAction={
      <Stack direction="row" alignItems="center" spacing={2}>
        <Button variant="contained" onClick={onSearchCourses}>
          Procurar por cursos
        </Button>
        <Button variant="text" onClick={onAddExternalCourse}>
          + Adicionar curso externo
        </Button>
      </Stack>
    }
  />
);
